import { create } from 'zustand';

import {
  getPaymentMethodsV2,
  getPaymentMethodsV2Props,
} from '@/shared/actions/erp';
import {
  IPaymentMethodV2,
  IPaymentMethodV2DataRes,
  TipoPagoV2Enum,
} from '@/shared/interfaces/erp/system-settings';

interface PaymentMethodsV2State {
  isLoadingPaymentMethodsV2Paging: boolean;
  paymentMethodsV2Paging: IPaymentMethodV2DataRes;
  paymentMethodsV2FilterPaging: IPaymentMethodV2[];

  // Para filtrado en Preventa (3 niveles)
  paymentMethodsV2ByTipoPago: IPaymentMethodV2[];
  paymentMethodsV2ByEntidad: IPaymentMethodV2[];

  getPaymentMethodsV2: (params?: getPaymentMethodsV2Props) => Promise<void>;
  getPaymentMethodsV2FilterPaging: (params?: getPaymentMethodsV2Props) => void;
  getPaymentMethodsV2ByTipoPago: (tipoPago: TipoPagoV2Enum) => void;
  getPaymentMethodsV2ByEntidad: (tipoPago: TipoPagoV2Enum, entidadCodigo: string) => void;
  setIsLoading: (value: boolean) => void;
}

export const usePaymentMethodsV2Store = create<PaymentMethodsV2State>(set => ({
  paymentMethodsV2Paging: {
    count: 0,
    next: null,
    previous: null,
    numero_paginas: 0,
    data: [],
  },
  paymentMethodsV2FilterPaging: [],
  paymentMethodsV2ByTipoPago: [],
  paymentMethodsV2ByEntidad: [],

  isLoadingPaymentMethodsV2Paging: false,

  getPaymentMethodsV2FilterPaging: async params => {
    set({ isLoadingPaymentMethodsV2Paging: true });
    const res = await getPaymentMethodsV2(params);
    set({
      paymentMethodsV2FilterPaging: res.data.data.filter(e => e.estado),
      isLoadingPaymentMethodsV2Paging: false,
    });
  },

  getPaymentMethodsV2: async params => {
    set({ isLoadingPaymentMethodsV2Paging: true });
    const res = await getPaymentMethodsV2(params);
    set({ paymentMethodsV2Paging: res.data, isLoadingPaymentMethodsV2Paging: false });
  },

  // Filtra formas de pago por tipo (DÉBITO/CRÉDITO) para el nivel 2 de preventa
  getPaymentMethodsV2ByTipoPago: async (tipoPago: TipoPagoV2Enum) => {
    set({ isLoadingPaymentMethodsV2Paging: true });
    const res = await getPaymentMethodsV2({
      tipo_pago: tipoPago,
      aplica_home: true,
      estado: true,
      filterByState: false,
    });
    set({
      paymentMethodsV2ByTipoPago: res.data.data,
      paymentMethodsV2ByEntidad: [], // Limpiar nivel 3 al cambiar nivel 1
      isLoadingPaymentMethodsV2Paging: false,
    });
  },

  // Filtra formas de pago por tipo + entidad para el nivel 3 de preventa
  getPaymentMethodsV2ByEntidad: async (tipoPago: TipoPagoV2Enum, entidadCodigo: string) => {
    set({ isLoadingPaymentMethodsV2Paging: true });
    const res = await getPaymentMethodsV2({
      tipo_pago: tipoPago,
      entidad_financiera: entidadCodigo,
      aplica_home: true,
      estado: true,
      filterByState: false,
    });
    set({
      paymentMethodsV2ByEntidad: res.data.data,
      isLoadingPaymentMethodsV2Paging: false,
    });
  },

  setIsLoading: value => set({ isLoadingPaymentMethodsV2Paging: value }),
}));
